import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'atlas-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent {
  @Output() textChange = new EventEmitter<string>();
  text: string;
  public isFocused: boolean = true;

  focused(focused: boolean): void {
    this.isFocused = focused;
  }
}
